module.exports = __webpack_public_path__ + "img/vertical_2_1_2.db12a367.png";